import { __awaiter, __generator } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyEmailFromMail } from '../../../services/api/OnboardingServices';
import endpoints from '../../../services/endpoints';
import { useLoadingActions } from '../../../context&providers/providers/Loading';
var VerifyEmail = function () {
    var searchParams = useSearchParams()[0];
    var navigate = useNavigate();
    var _a = useLoadingActions(), showLoading = _a.showLoading, hideLoading = _a.hideLoading;
    var email_param = searchParams.get("email");
    var token_param = searchParams.get("token");
    var verifyEmailOnLoad = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(email_param && token_param)) return [3 /*break*/, 2];
                    showLoading();
                    return [4 /*yield*/, verifyEmailFromMail(email_param, token_param)];
                case 1:
                    res = _a.sent();
                    console.log(res);
                    if (res.status === 200) {
                        navigate(endpoints.web.profileCompletion);
                    }
                    hideLoading();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        verifyEmailOnLoad();
    }, []);
    return (_jsx("div", { children: "Verifying ...." }));
};
export default VerifyEmail;
